
import { Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, int32_type, option_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { hasFailedUploads, Msg, FileUploadStatus, FileUploadStatus_$reflection, FileValidationStatus_$reflection } from "./Types.js";
import { toArray, exists, empty as empty_1, filter, collect, length, tryItem, ofArray, isEmpty, singleton, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { stringHash, comparePrimitives, defaultOf as defaultOf_1, equals, int32ToString, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { isNullOrWhiteSpace, concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Loading_Circle from "../../../public/assets/icons/Loading_Circle.svg";
import Check_Circle from "../../../public/assets/icons/Check_Circle.svg";
import Delete_Circle from "../../../public/assets/icons/Delete_Circle.svg";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createElement } from "react";
import React from "react";
import { Button, TextButton, IconButton } from "../../Components/Button.js";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { useTranslation } from "react-i18next";
import { nativeType, useDrop } from "../../Bindings/Fable.ReactDnD.js";
import { item, equalsWith } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { map as map_2, empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Upload_File from "../../../public/assets/icons/Upload_File.svg";
import { TextValue } from "../../Components/Text.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { FSharpSet__Contains, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { List_distinct } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { SectionContainer } from "../../Widgets/Container.js";
import { WarningAlert, ErrorAlert, InformationAlert } from "../../Components/Alert.js";
import { FormState__getValidation } from "../../Shared/Shared.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import { Checkbox } from "../../Components/Checkbox.js";

export class FileTableRow extends Record {
    constructor(Id, FileId, FileName, ValidationStatus, InventoryNumber, RowIndex, UploadStatus) {
        super();
        this.Id = Id;
        this.FileId = FileId;
        this.FileName = FileName;
        this.ValidationStatus = ValidationStatus;
        this.InventoryNumber = InventoryNumber;
        this.RowIndex = RowIndex;
        this.UploadStatus = UploadStatus;
    }
}

export function FileTableRow_$reflection() {
    return record_type("Importer.InspectionResult.View.FileTableRow", [], FileTableRow, () => [["Id", string_type], ["FileId", string_type], ["FileName", string_type], ["ValidationStatus", FileValidationStatus_$reflection()], ["InventoryNumber", option_type(string_type)], ["RowIndex", option_type(int32_type)], ["UploadStatus", FileUploadStatus_$reflection()]]);
}

function toTableRows(selectedFile) {
    const matchValue = selectedFile.ValidationStatus;
    let matchResult, links_1;
    if (matchValue.tag === 1) {
        if (!isEmpty(matchValue.fields[0])) {
            matchResult = 0;
            links_1 = matchValue.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return map((link) => (new FileTableRow(`${selectedFile.Id}#${link.RowIndex}`, selectedFile.Id, selectedFile.File.name, selectedFile.ValidationStatus, link.InventoryNumber, link.RowIndex, link.UploadStatus)), links_1);
        default:
            return singleton(new FileTableRow(selectedFile.Id, selectedFile.Id, selectedFile.File.name, selectedFile.ValidationStatus, undefined, undefined, new FileUploadStatus(0, [])));
    }
}

function UploadStatusIcon(status) {
    let elems, elems_1, elems_2;
    switch (status.tag) {
        case 1:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-primary", "animate-spin"])], (elems = [Loading_Circle()], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        case 2:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-green"])], (elems_1 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        case 3:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-red"])], (elems_2 = [Delete_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
        default:
            return defaultOf();
    }
}

function createFileColumnDefinitions(t, dispatch, isUploading) {
    return [new ColumnDefinition$1("fileName", "", t("general.file_name"), (row) => (new CellContent(0, [row.FileName])), "none", "text"), new ColumnDefinition$1("validationStatus", "", t("importer.documents.check_status"), (row_1) => {
        let matchValue;
        return new CellContent(0, [(matchValue = row_1.ValidationStatus, (matchValue.tag === 2) ? t("importer.inspection_result_import.not_linked") : ((matchValue.tag === 0) ? t("importer.documents.not_checked_yet") : t("importer.inspection_result_import.linked")))]);
    }, "select", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_2) => (new CellContent(0, [defaultArg(row_2.InventoryNumber, "-")])), "none", "text"), new ColumnDefinition$1("rowIndex", "", t("importer.inspection_result_import.excel_row"), (row_3) => (new CellContent(0, [defaultArg(map_1(int32ToString, row_3.RowIndex), "-")])), "none", "text"), new ColumnDefinition$1("uploadStatus", "", t("importer.documents.upload_status"), (row_4) => (new CellContent(2, [UploadStatusIcon(row_4.UploadStatus)])), "none", "text"), new ColumnDefinition$1("actions", "", "", (row_5) => (new CellContent(2, [(!isUploading && equals(row_5.UploadStatus, new FileUploadStatus(0, []))) ? createElement(IconButton, {
        ComponentState: "enabled",
        Icon: Delete_1(),
        OnClick: () => {
            dispatch(new Msg(5, [row_5.FileId]));
        },
        TestId: concat("remove-file-", ...row_5.Id),
    }) : defaultOf()])), "none", "text")];
}

function createValidationColumnDefinitions(t) {
    return [new ColumnDefinition$1("rowIndex", "", t("importer.inspection_result_import.excel_row"), (row) => (new CellContent(0, [int32ToString(row.RowIndex)])), "none", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_1) => (new CellContent(0, [row_1.InventoryNumber])), "text", "text"), new ColumnDefinition$1("toolDisplayName", "", t("general.tool"), (row_2) => (new CellContent(0, [row_2.ToolDisplayName])), "text", "text"), new ColumnDefinition$1("templateName", "", t("inspection_result.template"), (row_3) => (new CellContent(0, [row_3.TemplateName])), "text", "text"), new ColumnDefinition$1("inspectionDate", "", t("inspection_result.date"), (row_4) => (new CellContent(0, [row_4.InspectionDate])), "none", "text"), new ColumnDefinition$1("result", "", t("inspection_result.result"), (row_5) => (new CellContent(0, [row_5.Result])), "select", "text"), new ColumnDefinition$1("comment", "", t("inspection_result.comment"), (row_6) => (new CellContent(0, [row_6.Comment])), "none", "text"), new ColumnDefinition$1("document1", "", t("importer.inspection_result_import.document1"), (row_7) => (new CellContent(0, [defaultArg(tryItem(0, row_7.DocumentFileNames), "")])), "none", "text"), new ColumnDefinition$1("document2", "", t("importer.inspection_result_import.document2"), (row_8) => (new CellContent(0, [defaultArg(tryItem(1, row_8.DocumentFileNames), "")])), "none", "text"), new ColumnDefinition$1("document3", "", t("importer.inspection_result_import.document3"), (row_9) => (new CellContent(0, [defaultArg(tryItem(2, row_9.DocumentFileNames), "")])), "none", "text"), new ColumnDefinition$1("status", "", t("updater.validation_table.row_status"), (row_10) => {
        const matchValue = row_10.Status;
        return (matchValue.tag === 1) ? (new CellContent(0, [t(matchValue.fields[0])])) : (new CellContent(0, [t("updater.validation_table.valid")]));
    }, "select", "text")];
}

function ExcelUploadArea(props) {
    let elems_1, elems;
    const patternInput = useTranslation();
    const validateFile = (file) => {
        const formData = new FormData();
        formData.append(file.name, file);
        props.OnValidate(formData);
    };
    const patternInput_1 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let testExpr, testExpr_1;
            const matchValue = draggedFile.files;
            if (props.ComponentState === "disabled") {
            }
            else if (matchValue == null) {
            }
            else if ((testExpr = matchValue, !equalsWith(equals, testExpr, defaultOf_1()) && (testExpr.length === 0))) {
            }
            else if ((testExpr_1 = matchValue, !equalsWith(equals, testExpr_1, defaultOf_1()) && (testExpr_1.length === 1))) {
                const file_1 = item(0, matchValue);
                validateFile(file_1);
            }
        },
    });
    const dropData = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton_1("border"), delay(() => append(singleton_1("rounded"), delay(() => append(singleton_1("border-dashed"), delay(() => append(singleton_1("border-primary"), delay(() => append(singleton_1("p-4"), delay(() => ((dropData.isOver && dropData.canDrop) ? singleton_1("bg-background") : empty()))))))))))))))], ["ref", patternInput_1[1]], (elems_1 = [createElement(TextButton, {
        ComponentState: props.ComponentState,
        Label: patternInput[0]("file_upload.select_file"),
        OnClick: () => {
            const element = document.getElementById("inspection-result-excel-upload");
            element.click();
        },
        TestId: "open-file-explorer-test-id",
        Variant: "blueButton",
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-center"])], (elems = [reactElement("input", {
        id: "inspection-result-excel-upload",
        className: join(" ", ["hidden"]),
        type: "file",
        accept: ".xls, .xlsx",
        disabled: props.ComponentState === "disabled",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                validateFile(files.item(0));
            }
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function DropArea(props) {
    let elems_2, elems, elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let files;
            const matchValue = draggedFile.files;
            let matchResult, files_1;
            if (matchValue != null) {
                if ((files = matchValue, (files.length > 0) && (props.ComponentState === "enabled"))) {
                    matchResult = 0;
                    files_1 = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    props.OnFilesSelected(ofArray(files_1));
                    break;
                }
                case 1: {
                    break;
                }
            }
        },
    });
    const dropData = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton_1("border"), delay(() => append(singleton_1("rounded"), delay(() => append(singleton_1("border-dashed"), delay(() => append(singleton_1("border-primary"), delay(() => append(singleton_1("p-8"), delay(() => append(singleton_1("flex"), delay(() => append(singleton_1("flex-col"), delay(() => append(singleton_1("items-center"), delay(() => append(singleton_1("justify-center"), delay(() => ((dropData.isOver && dropData.canDrop) ? singleton_1("bg-background") : empty()))))))))))))))))))))))], ["ref", patternInput_1[1]], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-12", "w-12", "text-primary", "mb-4"])], (elems = [Upload_File()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("importer.inspection_result_import.drag_drop_hint"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_1 = [createElement(TextButton, {
        ComponentState: props.ComponentState,
        Label: t("file_upload.select_file"),
        OnClick: () => {
            const element = document.getElementById("inspection-result-document-upload");
            element.click();
        },
        TestId: "open-document-explorer-test-id",
        Variant: "blueButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("input", {
        id: "inspection-result-document-upload",
        className: join(" ", ["hidden"]),
        type: "file",
        multiple: true,
        disabled: props.ComponentState === "disabled",
        onChange: (ev) => {
            const fileList = ev.target.files;
            if (!(fileList == null)) {
                const files_2 = toList(delay(() => map_2((i) => fileList.item(i), rangeDouble(0, 1, fileList.length - 1))));
                if (length(files_2) > 0) {
                    props.OnFilesSelected(files_2);
                }
            }
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function getMissingDocuments(validationResult, uploadedFiles) {
    if (validationResult != null) {
        const result = validationResult;
        const uploadedFileNames = ofList(map((sf) => (sf.File.name.normalize('NFC')).toLocaleLowerCase(), uploadedFiles), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
        return List_distinct(collect((row) => filter((d_1) => {
            if (!isNullOrWhiteSpace(d_1)) {
                return !FSharpSet__Contains(uploadedFileNames, (d_1.normalize('NFC')).toLocaleLowerCase());
            }
            else {
                return false;
            }
        }, map((d) => d.trim(), row.DocumentFileNames)), result.Rows), {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: (x_1) => (stringHash(x_1) | 0),
        });
    }
    else {
        return empty_1();
    }
}

export function View(props) {
    let elems_16;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const isUploading = exists((sf) => {
        const matchValue = sf.ValidationStatus;
        if (matchValue.tag === 1) {
            return exists((l) => equals(l.UploadStatus, new FileUploadStatus(1, [])), matchValue.fields[0]);
        }
        else {
            return false;
        }
    }, state_1.SelectedFiles);
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    const fileTableRows = toArray(collect(toTableRows, state_1.SelectedFiles));
    const fileColumnDefinitions = createFileColumnDefinitions(t, dispatch, isUploading ? true : state_1.FormState.IsLoading);
    const validationColumnDefinitions = createValidationColumnDefinitions(t);
    const missingDocuments = getMissingDocuments(state_1.ValidationResult, state_1.SelectedFiles);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_16 = toList(delay(() => {
        let elems_4, elems_3, elems_2, elems, elems_1;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]"])], (elems_4 = [createElement(SectionContainer, {
            Content: reactElement("div", createObj(singleton((elems_3 = [createElement(InformationAlert, {
                Label: "importer.inspection_result_import.info",
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-8", "mt-4"])], (elems_2 = [reactElement("div", createObj(singleton((elems = [createElement(TextButton, {
                ComponentState: componentState,
                Label: t("importer.inspection_result_import.download_template"),
                OnClick: () => {
                    dispatch(new Msg(10, []));
                },
                TestId: "download-inspection-result-template",
                Variant: "blueButton",
            })], ["children", reactApi.Children.toArray(Array.from(elems))])))), reactElement("div", createObj(singleton((elems_1 = [createElement(ExcelUploadArea, {
                ComponentState: componentState,
                OnValidate: (formData) => {
                    dispatch(new Msg(2, [formData]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])))),
            Title: "importer.inspection_result_import.header",
        })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
            let matchValue_1, msg_1, elems_5;
            return append((matchValue_1 = FormState__getValidation(state_1.FormState, t, "global"), (matchValue_1 == null) ? singleton_1(defaultOf()) : ((msg_1 = matchValue_1, singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "max-w-[75rem]"])], (elems_5 = [createElement(ErrorAlert, {
                Label: msg_1,
            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))))))), delay(() => {
                let elems_6;
                return append(state_1.FormState.IsLoading ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-6"])], (elems_6 = [createElement(Skeleton, {
                    Variant: "table",
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty(), delay(() => {
                    let elems_7;
                    return append(state_1.IsImported ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "max-w-[75rem]"])], (elems_7 = toList(delay(() => (hasFailedUploads(state_1.SelectedFiles) ? singleton_1(createElement(WarningAlert, {
                        Label: "importer.some_uploads_failed",
                    })) : singleton_1(createElement(InformationAlert, {
                        Label: "importer.successful_imported",
                    }))))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : empty(), delay(() => {
                        let matchValue_2, validationResult, elems_8;
                        return append((!state_1.FormState.IsLoading && !state_1.IsImported) ? ((matchValue_2 = state_1.ValidationResult, (matchValue_2 == null) ? singleton_1(defaultOf()) : ((validationResult = matchValue_2, append(!isEmpty(missingDocuments) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "max-w-[75rem]"])], (elems_8 = [createElement(ErrorAlert, {
                            Label: (t("importer.inspection_result_import.missing_documents") + ": ") + join(", ", missingDocuments),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty(), delay(() => {
                            let elems_9;
                            return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-4"])], (elems_9 = [createElement(Button, {
                                ComponentState: ((validationResult.IsValid && isEmpty(missingDocuments)) && !isUploading) ? "enabled" : "disabled",
                                Label: t("importer.save"),
                                OnClick: () => {
                                    dispatch(new Msg(0, []));
                                },
                                TestId: "import-inspection-results-btn",
                                Variant: "primary",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => {
                                let elems_10;
                                return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "h-[1800px]"])], (elems_10 = [createElement(InfiniteTable, {
                                    ColumnDefinitions: validationColumnDefinitions,
                                    Controls: empty_1(),
                                    Options: {
                                        BorderStyle: "row",
                                        CSVDownload: false,
                                        ConfigurableColumns: false,
                                        CustomTableFilters: false,
                                        DefaultSortColumn: ["rowIndex", "asc"],
                                        Fullscreen: false,
                                        GlobalSearch: false,
                                        RowSelection: "disabled",
                                        SaveTableConfiguration: false,
                                        WithQueryParameters: false,
                                    },
                                    TableKey: "inspection-result-import-validation",
                                    TableRows: toArray(validationResult.Rows),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))));
                            }));
                        })))))) : empty(), delay(() => {
                            let elems_14, elems_13, elems_11, elems_12;
                            return append((!state_1.FormState.IsLoading && !state_1.IsImported) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]"])], (elems_14 = [createElement(SectionContainer, {
                                Content: reactElement("div", createObj(singleton((elems_13 = [createElement(InformationAlert, {
                                    Label: "importer.inspection_result_import.documents_info",
                                }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_11 = [createElement(DropArea, {
                                    ComponentState: componentState,
                                    OnFilesSelected: (files) => {
                                        dispatch(new Msg(4, [files]));
                                    },
                                })], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_12 = [Checkbox({
                                    ComponentState: componentState,
                                    IsChecked: state_1.IsVisibleForUserRole,
                                    Label: t("importer.documents.visible_for_user_role"),
                                    OnCheck: (value_24) => {
                                        dispatch(new Msg(6, [value_24]));
                                    },
                                    TestId: "inspection-result-import-visible-for-user-role",
                                })], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))])))),
                                Title: "importer.inspection_result_import.documents_header",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))) : empty(), delay(() => {
                                let elems_15;
                                return (!state_1.FormState.IsLoading && (length(state_1.SelectedFiles) > 0)) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "h-[600px]"])], (elems_15 = [createElement(InfiniteTable, {
                                    ColumnDefinitions: fileColumnDefinitions,
                                    Controls: empty_1(),
                                    Options: {
                                        BorderStyle: "row",
                                        CSVDownload: false,
                                        ConfigurableColumns: false,
                                        CustomTableFilters: false,
                                        DefaultSortColumn: ["fileName", "asc"],
                                        Fullscreen: false,
                                        GlobalSearch: false,
                                        RowSelection: "disabled",
                                        SaveTableConfiguration: false,
                                        WithQueryParameters: false,
                                    },
                                    TableKey: "inspection-result-import-files",
                                    TableRows: fileTableRows,
                                })], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))) : empty();
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_16))])])));
}

